import { useMemo } from 'react';
import { useReadOnlyWarning } from 'hooks';
import { atom, useAtom } from 'jotai/index';
import { IMultiSignWallet } from 'types';

import { useArchivedSafes } from './archivedSafes';
import { usePendingSafes } from './pendingSafes';
import { useSafes, useSubAccountForSafe } from './safes';

const currentSafeAtom = atom<IMultiSignWallet | undefined>(undefined);

export const useParrentSafe = () => {
  const [currentSafe] = useAtom(currentSafeAtom);
  const { safes } = useSafes();

  if (currentSafe?.parrentId) {
    return safes.find((safe) => safe._id === currentSafe.parrentId) as unknown as IMultiSignWallet;
  }

  return currentSafe;
};

export const useCurrentSafe = () => {
  const [currentSafe, setCurrentSafe] = useAtom(currentSafeAtom);
  const { safes } = useSafes();
  const { pendingSafes } = usePendingSafes();
  const { archivedSafes } = useArchivedSafes();
  const subAccountId = useSubAccountForSafe(currentSafe?._id || '');
  const isReadOnly = Boolean(useReadOnlyWarning());

  // TODO not sure mixing store and logiс in one place is a good idea, revisit later
  const selectedSafe = useMemo(() => {
    if (isReadOnly) {
      return currentSafe;
    } else {
      return [...safes, ...pendingSafes, ...archivedSafes].find(
        (safe) => safe._id === subAccountId
      );
    }
  }, [safes, archivedSafes, subAccountId, isReadOnly]);

  return { currentSafe: selectedSafe as unknown as IMultiSignWallet, setCurrentSafe };
};

// TODO do we need this? and why?
export const useInitializedCurrentSafe = () => {
  const { currentSafe } = useCurrentSafe();

  return {
    currentSafe: currentSafe as IMultiSignWallet,
  };
};
